import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { CardIceBreak } from 'System/Animation/Clip';

export default function IceCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    PlaySound('ice-break');

    const discard = system.getCardByID(taskData.discard);
    discard.getComponent(Renderable).visible = true;

    system.taskQueue.queue(
        new AnimationClipTask(
            new CardIceBreak(system.getCardByID(taskData.source), {
                discard: discard,
                cardScore: taskData.cardScore,
                scene: system.scene,
            }),
        ),
    );
}
